import UserDocs from "../modules/Users/UserDocs";
import ManageMasterData from "../modules/admin/ManageMasterData";
import ManagePermissions from "../modules/admin/ManagePermissions";
import ManageRoles from "../modules/admin/ManageRoles";
import TestResults from "../modules/admin/TestResults";
import Users from "../modules/admin/Users";
import DeleteAccount from "../modules/auth/DeleteAccount";
import GetPassword from "../modules/auth/GetPassword";
import LoginWithOtp from "../modules/auth/LoginWithOtp";
import AdmissionDashBoard from "../modules/dashboard/AdmissionDashBoard";
import Dashboard from "../modules/dashboard/Dashboard";
import InvoiceDashboard from "../modules/dashboard/InvoiceDashboard";
import PlacementDashboard from "../modules/dashboard/PlacementDashboard";
import ToolDashboard from "../modules/dashboard/ToolDashboard";
import Home from "../modules/home/Home";
import CompareInvoice from "../modules/invoice/CompareInvoice";
import DownloadInvoiceExcel from "../modules/invoice/DownloadInvoiceExcel";
import CheckErrors from "../modules/invoice/CheckErrors";
import InvoiceUpload from "../modules/invoice/InvoiceUpload";
import Usage from "../modules/invoice/Usage";
import SingleDraftDoc from "../modules/invoice/SingleDraftDoc";
import AddValidation from "../modules/validation/AddValidation";
import GetValidations from "../modules/validation/GetValidations";
import ComparatorUpload from "../modules/invoice/ComparatorUpload";
import ComparatorDashboard from "../modules/dashboard/ComparatorDashboard";
import MsmeDashboard from "../modules/dashboard/MsmeDashboard";
import DownloadInsuranceOperations from "../modules/invoice/DownloadInsuranceOperations";
import CommonDocumentUpload from "../modules/commonDocument/CommonDocumentUpload";
import DeedProcessorUpload from "../modules/deepProcessor.js/DeedProcessorUpload";
import DeedProcessorSingle from "../modules/deepProcessor.js/DeedProcessorSingle";
import DeedProcessorDashboard from "../modules/deepProcessor.js/DeedProcessorDashboard";
import PoDashboard from "../modules/dashboard/PoDashboard";
import MergeExcel from "../modules/validation/MergeExcel";
import TempViewData from "../modules/temp/TempViewData";
import TempUpload from "../modules/temp/TempUpload";
import ManufacturingInvoiceDashboard from "../modules/dashboard/ManufacturingInvoiceDashboard";
import HofDashboard from "../modules/dashboard/HofDashboard";
import MarutiDeedUpload from "../modules/marutiDeedProcessor/MarutiDeedUpload";
import MarutiDocUpload from "../modules/maruti/MarutiDocUpload";
import MarutiDashboard from "../modules/maruti/MarutiDashboard";
import MarutiDocView from "../modules/maruti/MarutiDocView";
import MarutiViewSingle from "../modules/maruti/MarutiViewSingle";
import LegalDashboard from "../modules/dashboard/LegalDashboard";
import LegalCalendar from "../modules/dashboard/LegalCalendar";
import SignUp from "../modules/auth/SignUp";
import SignIn from "../modules/auth/SignIn";
import ForgotPassword from "../modules/auth/ForgotPassword";

export const appRoutes = [
  { url: "/", comp: <Home />, noAuth: true },
  { url: "login", comp: <SignIn />, noAuth: true },
  { url: "signup", comp: <SignUp />, noAuth: true },
  { url: "password", comp: <GetPassword />, noAuth: true },
  { url: "verify/account", comp: <LoginWithOtp />, noAuth: true },
  { url: "reset/password", comp: <ForgotPassword />, noAuth: true },
  {
    url: "account/delete",
    comp: <DeleteAccount />,
    noAuth: true,
  },
  {
    url: "usage",
    comp: <Usage />,
  },

  { url: "/arts/dashboard", comp: <ToolDashboard /> },
  { url: "/legal/dashboard", comp: <LegalDashboard /> },
  { url: "/legal/calendar", comp: <LegalCalendar /> },
  { url: "/policy/dashboard", comp: <ToolDashboard /> },
  { url: "/invoice-extraction/dashboard", comp: <InvoiceDashboard /> },
  { url: "/kyc-individual/dashboard", comp: <ToolDashboard /> },
  { url: "/education/dashboard", comp: <AdmissionDashBoard /> },
  { url: "/kyc-motor/dashboard", comp: <ToolDashboard /> },
  { url: "/kyc-health/dashboard", comp: <ToolDashboard /> },
  { url: "/kyc-company/dashboard", comp: <ToolDashboard /> },
  { url: "/po-extraction/dashboard", comp: <PoDashboard /> },
  { url: "/warehouse-management/dashboard", comp: <ToolDashboard /> },

  { url: "dashboard", comp: <Dashboard /> },

  {
    url: "invoice-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "invoice-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "invoice-extraction/single",
    comp: <CompareInvoice />,
  },

  {
    url: "po-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "po-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "po-extraction/single",
    comp: <CompareInvoice />,
  },

  {
    url: "kyc-company/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "kyc-company/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "kyc-company/single",
    comp: <CompareInvoice />,
  },

  {
    url: "kyc-individual/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "kyc-individual/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "kyc-individual/single",
    comp: <CompareInvoice />,
  },

  {
    url: "kyc-health/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "kyc-health/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "kyc-health/single",
    comp: <CompareInvoice />,
  },

  {
    url: "kyc-motor/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "kyc-motor/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "kyc-motor/single",
    comp: <CompareInvoice />,
  },

  {
    url: "education/docs/upload",
    comp: <ComparatorUpload layout="education" />,
  },
  {
    url: "education/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "education/single",
    comp: <CompareInvoice />,
  },
  { url: "doc/users", comp: <UserDocs /> },

  {
    url: "policy/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "policy/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "policy/single",
    comp: <CompareInvoice />,
  },

  { url: "manage/users", comp: <Users /> },
  // { url: "dashboard", comp: <TestInvoice /> },
  {
    url: "manage/errors",
    comp: <CheckErrors />,
  },

  {
    url: "legal/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "legal/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "legal/single",
    comp: <CompareInvoice />,
  },

  {
    url: "arts/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "arts/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "arts/single",
    comp: <CompareInvoice />,
  },

  {
    url: "warehouse-management/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "warehouse-management/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "warehouse-management/single",
    comp: <CompareInvoice />,
  },

  { url: "/marksheet-extraction-ccf/dashboard", comp: <ToolDashboard /> },
  {
    url: "marksheet-extraction-ccf/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "marksheet-extraction-ccf/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "marksheet-extraction-ccf/single",
    comp: <CompareInvoice />,
  },

  { url: "/marksheet-extraction-cbcs/dashboard", comp: <ToolDashboard /> },
  {
    url: "marksheet-extraction-cbcs/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "marksheet-extraction-cbcs/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "marksheet-extraction-cbcs/single",
    comp: <CompareInvoice />,
  },

  { url: "/recruitment/dashboard", comp: <ToolDashboard /> },
  {
    url: "recruitment/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "recruitment/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "recruitment/single",
    comp: <CompareInvoice />,
  },

  { url: "/placement/dashboard", comp: <PlacementDashboard /> },
  {
    url: "placement/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "placement/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "placement/single",
    comp: <CompareInvoice />,
  },
  {
    url: "manage/masterData",
    comp: <ManageMasterData />,
  },
  {
    url: "manage/role",
    comp: <ManageRoles />,
  },
  {
    url: "manage/permission",
    comp: <ManagePermissions />,
  },
  {
    url: "test/results",
    comp: <TestResults />,
  },

  { url: "/fir/dashboard", comp: <ToolDashboard /> },
  {
    url: "fir/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "fir/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "fir/single",
    comp: <CompareInvoice />,
  },

  { url: "/tender-management/dashboard", comp: <ToolDashboard /> },
  {
    url: "tender-management/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "tender-management/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "tender-management/unsaved/single",
    comp: <SingleDraftDoc />,
  },
  { url: "/pricebook-management/dashboard", comp: <ToolDashboard /> },
  {
    url: "pricebook-management/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "pricebook-management/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "pricebook-management/unsaved/single",
    comp: <SingleDraftDoc />,
  },
  {
    url: "birth-register-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "birth-register-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "birth-register-extraction/single",
    comp: <CompareInvoice />,
  },

  {
    url: "loan/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "loan/dashboard",
    comp: <ToolDashboard />,
  },
  {
    url: "loan/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "loan/single",
    comp: <CompareInvoice />,
  },

  { url: "/birth-khata-extraction/dashboard", comp: <ToolDashboard /> },
  {
    url: "birth-khata-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "birth-khata-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "birth-khata-extraction/single",
    comp: <CompareInvoice />,
  },

  { url: "/voter-list-extraction/dashboard", comp: <ToolDashboard /> },
  {
    url: "voter-list-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "voter-list-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "voter-list-extraction/single",
    comp: <CompareInvoice />,
  },
  { url: "/business-card-extraction/dashboard", comp: <ToolDashboard /> },
  {
    url: "business-card-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "business-card-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "business-card-extraction/single",
    comp: <CompareInvoice />,
  },
  {
    url: "validation/add",
    comp: <AddValidation />,
  },
  {
    url: "validations",
    comp: <GetValidations />,
  },
  {
    url: "document-comparator/docs/upload",
    comp: <ComparatorUpload />,
  },
  {
    url: "document-comparator/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "document-comparator/single",
    comp: <CompareInvoice />,
  },
  {
    url: "document-comparator/dashboard",
    comp: <ComparatorDashboard />,
  },
  { url: "/case-processor/dashboard", comp: <MsmeDashboard /> },
  {
    url: "case-processor/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "case-processor/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "case-processor/single",
    comp: <CompareInvoice />,
  },
  { url: "/insurance-operations/dashboard", comp: <ToolDashboard /> },
  {
    url: "insurance-operations/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "insurance-operations/docs/view",
    comp: <DownloadInsuranceOperations />,
  },
  {
    url: "insurance-operations/single",
    comp: <CompareInvoice />,
  },
  {
    url: "document-extractor/docs/upload",
    comp: <CommonDocumentUpload />,
  },
  {
    url: "document-extractor/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "document-extractor/dashboard",
    // comp: <CommonDocumentUpload />,
  },

  {
    url: "death-register-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "death-register-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "death-register-extraction/single",
    comp: <CompareInvoice />,
  },

  {
    url: "death-khata-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "death-khata-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "death-khata-extraction/single",
    comp: <CompareInvoice />,
  },
  { url: "/hospital-invoice-management/dashboard", comp: <ToolDashboard /> },
  {
    url: "hospital-invoice-management/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "hospital-invoice-management/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "hospital-invoice-management/single",
    comp: <CompareInvoice />,
  },

  {
    url: "deed-processor/docs/upload",
    comp: <DeedProcessorUpload />,
  },
  {
    url: "deed-processor/dashboard",
    comp: <DeedProcessorDashboard />,
  },
  {
    url: "deed-processor/single",
    comp: <DeedProcessorSingle />,
  },

  {
    url: "maruti-deed-processor/upload",
    comp: <MarutiDeedUpload />,
  },

  {
    url: "pnidDocument-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "pnidDocument-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "pnidDocument-extraction/single",
    comp: <CompareInvoice />,
  },
  {
    url: "excel/merge",
    comp: <MergeExcel />,
  },
  {
    url: "fraud_detection-extraction/dashboard",
    comp: <ToolDashboard />,
  },
  {
    url: "fraud_detection-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "fraud_detection-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "fraud_detection-extraction/single",
    comp: <CompareInvoice />,
  },
  {
    url: "manufacturing/dashboard",
    comp: <ManufacturingInvoiceDashboard />,
  },
  {
    url: "manufacturing/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "manufacturing/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "manufacturing/single",
    comp: <CompareInvoice />,
  },
  { url: "/hof-extraction/dashboard", comp: <HofDashboard /> },
  {
    url: "hof-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "hof-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "hof-extraction/single",
    comp: <CompareInvoice />,
  },
  { url: "/exam/dashboard", comp: <HofDashboard /> },
  {
    url: "exam/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "exam/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "exam/single",
    comp: <CompareInvoice />,
  },
  { url: "/motor-claim-invoice/dashboard", comp: <HofDashboard /> },
  {
    url: "motor-claim-invoice/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "motor-claim-invoice/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "motor-claim-invoice/single",
    comp: <CompareInvoice />,
  },
  {
    url: "maruti-doc-management/dashboard",
    comp: <MarutiDashboard />,
  },
  {
    url: "maruti-doc-management/docs/upload",
    comp: <MarutiDocUpload />,
  },
  {
    url: "maruti-doc-management/docs/view",
    comp: <MarutiDocView />,
  },
  {
    url: "maruti-doc-management/single",
    comp: <MarutiViewSingle />,
  },
  {
    url: "/discharge-summary-ink-extraction/dashboard",
    comp: <ToolDashboard />,
  },
  {
    url: "discharge-summary-ink-extraction/docs/upload",
    comp: <InvoiceUpload />,
  },
  {
    url: "discharge-summary-ink-extraction/docs/view",
    comp: <DownloadInvoiceExcel />,
  },
  {
    url: "discharge-summary-ink-extraction/single",
    comp: <CompareInvoice />,
  },
];
